import JackpotPanel from "./JackpotPanel";

export default JackpotPanel;